function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import _ from "lodash";
import { systemFontList } from "@/config/system-font.js";
import layer from "./layer.vue";
import { defineComponent, onMounted, watch, reactive, computed, ref } from "vue";
import { ListType } from "./type";
import { definePropType } from "@types-vue/props";
import { getAssetTag, getMainTagAssetList, getCommonComponentList } from "@/api/common/asset";
import { assetsList } from "@pt/api/assets/index";
export default defineComponent({
    props: {
        config: {
            type: definePropType(Object),
            required: true
        },
        model: {
            type: definePropType(Object),
            required: true
        },
        langConfig: {
            type: definePropType(Object),
            required: true
        },
        fontSelectorLoading: {
            type: Boolean,
            default: false
        },
        offsetConfig: {
            type: definePropType(Object)
        },
        requestParams: {
            type: Object,
            default: function() {}
        },
        layerDialogConfig: {
            type: Object,
            default: function() {}
        },
        // 自定义字体  list:是否展示资产库数据
        assetFontConfig: {
            type: definePropType(Object),
            default: function() {}
        },
        disabled: Boolean,
        customUpdateDialog: definePropType(Function)
    },
    components: {
        layer: layer
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var layerRef = ref(null);
        var layerVisible = ref(false);
        var searchQuery = reactive({
            name: "",
            tag_ids: [],
            group_id: 0,
            type: 9
        });
        var currentGroup = ref({
            id: 0,
            name: "",
            type: 0
        });
        var systemFont = ref([
            {
                postscript_name: "system-font",
                file_url: "",
                thumb_url: "",
                name: props.langConfig.system
            }, 
        ]);
        var forbiddenFont = ref([
            {
                postscript_name: "forbidden-font",
                file_url: "",
                thumb_url: "",
                name: props.langConfig.forbidden
            }, 
        ]);
        var layerListType = ref(ListType.ALL);
        var listLoading = ref(false);
        var assetFont = ref([]);
        var allFont = ref([]);
        var assistTag = ref([]);
        var originFontName = computed(function() {
            return _.get(props.model, props.config.prop) || "";
        });
        var fontName = computed(function() {
            return originFontName.value || "";
        });
        var currentFont1 = computed(function() {
            var currentFont = props.config.field.options.filter(function(item) {
                return item.value === fontName.value;
            });
            if (!_.isEmpty(currentFont)) {
                // font列表对象转换
                return currentFont.map(function(font) {
                    return {
                        file_url: font.url || "",
                        thumb_url: font.svg || "",
                        name: font.label || "",
                        postscript_name: font.value
                    };
                });
            } else if (_.isEmpty(currentFont) && fontName.value && systemFontList.indexOf(fontName.value) === -1) {
                return _.cloneDeep(forbiddenFont.value);
            }
            return _.cloneDeep(systemFont.value);
        });
        var switchVisible = function() {
            var _$ref;
            (_$ref = layerRef.value) === null || _$ref === void 0 ? void 0 : _$ref.switchVisible();
        };
        var handleClick = function() {
            if (props.fontSelectorLoading) return;
            switchVisible();
        };
        var handleFontChange = function(val) {
            emit("update-field", {
                prop: props.config.prop,
                value: val
            });
        };
        var handleSelectFont = function(font) {
            // switchVisible()
            handleFontChange(font);
        };
        var getAllFont = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getMainTagAssetList(_objectSpread({
                                type: searchQuery.type,
                                limit: 4
                            }, props.requestParams), {});
                        case 2:
                            res = _ctx.sent;
                            if (!props.assetFontConfig.list) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 6;
                            return getAssetsList();
                        case 6:
                            assetFont.value = _ctx.sent;
                        case 7:
                            listLoading.value = false;
                            allFont.value = _.get(res, "data.data.list") || [];
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getAllFont() {
                return _ref.apply(this, arguments);
            };
        }();
        function getAssetsList() {
            return _getAssetsList.apply(this, arguments);
        }
        function _getAssetsList() {
            _getAssetsList = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var params, res, list, _args = arguments;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            params = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {
                                search_field: "name",
                                keyword: ""
                            };
                            _ctx.next = 3;
                            return assetsList(_objectSpread({
                                page: 1,
                                page_size: 1000,
                                types: [
                                    "font"
                                ],
                                formats: [
                                    "ttf",
                                    "otf"
                                ],
                                order: "-updated_time"
                            }, params));
                        case 3:
                            res = _ctx.sent;
                            list = _.get(res, "data.data.list") || [];
                            _.map(list, function(item) {
                                var payload = JSON.parse(item.payload);
                                item.postscript_name = item.id + "|" + payload.postscript_name;
                                item.thumb_url = item.cover_url || "";
                                item.source = 3 // 自定义数据source=3
                                ;
                            });
                            return _ctx.abrupt("return", list);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getAssetsList.apply(this, arguments);
        }
        var getFontByTag = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var postdata, fontList, list, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            postdata = {
                                page: 1,
                                page_size: 1000
                            };
                            if (searchQuery.name) {
                                postdata.name = searchQuery.name;
                            }
                            if (searchQuery.tag_ids.length) {
                                postdata.tag_ids = searchQuery.tag_ids.join(",");
                            }
                            if (searchQuery.group_id) {
                                postdata.group_id = searchQuery.group_id;
                            }
                            if (!searchQuery.tag_ids.length && !searchQuery.group_id) {
                                postdata.type = 9;
                            }
                            fontList = [];
                            list = [];
                            if (!(currentGroup.value.id !== -1)) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 10;
                            return getCommonComponentList(_objectSpread({}, postdata, props.requestParams), {});
                        case 10:
                            res = _ctx.sent;
                            fontList = _.get(res, "data.data.list") || [];
                        case 12:
                            if (!(!searchQuery.tag_ids.length && props.assetFontConfig.list)) {
                                _ctx.next = 16;
                                break;
                            }
                            _ctx.next = 15;
                            return getAssetsList({
                                search_field: "name",
                                keyword: searchQuery.name
                            });
                        case 15:
                            list = _ctx.sent;
                        case 16:
                            listLoading.value = false;
                            allFont.value = [
                                _objectSpreadProps(_objectSpread({}, _.pick(currentGroup.value, [
                                    "name"
                                ])), {
                                    id: 0,
                                    type: 0,
                                    assets: list.concat(fontList)
                                }), 
                            ];
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getFontByTag() {
                return _ref.apply(this, arguments);
            };
        }();
        var getAssistTag = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getAssetTag(_objectSpread({
                                type: 9
                            }, props.requestParams), {});
                        case 2:
                            res = _ctx.sent;
                            assistTag.value = _.get(res, "data.data.list") || [];
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getAssistTag() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleSearch = function() {
            listLoading.value = true;
            var isAll = !searchQuery.name && searchQuery.tag_ids.length === 0 && searchQuery.group_id === 0;
            if (isAll) {
                getAllFont();
            } else {
                getFontByTag();
            }
        };
        var handleUpdateGroup = function(group) {
            // 设置当前组
            currentGroup.value = group;
            // 更新请求数据
            if (group.type === 1) {
                searchQuery.group_id = group.id;
            } else {
                searchQuery.tag_ids = _.union(searchQuery.tag_ids.concat([
                    group.id
                ]));
            }
            if (group.id === 0) {
                searchQuery.name = "";
                searchQuery.tag_ids = [];
            }
            handleSearch();
        };
        var handleUpdateAssetGroup = function() {
            // 设置当前组
            currentGroup.value = {
                id: -1,
                name: "",
                type: -1
            };
            allFont.value = [
                {
                    name: "",
                    id: 0,
                    type: 0,
                    assets: assetFont.value
                }, 
            ];
        };
        var handleUpdateKeyword = function(keyword) {
            searchQuery.name = keyword;
            // 在自定义字体组
            if (currentGroup.value.id === -1 && searchQuery.tag_ids.length) {
                allFont.value = [
                    {
                        name: "",
                        id: 0,
                        type: 0,
                        assets: []
                    }, 
                ];
                return;
            }
            if (currentGroup.value.id === -1 && !keyword) {
                handleUpdateAssetGroup();
                return;
            }
            handleSearch();
        };
        var handleUpdateFilter = function(tags) {
            var temp = [];
            if (currentGroup.value.type === 2 && currentGroup.value.id !== 0) {
                temp.push(currentGroup.value.id);
            }
            searchQuery.tag_ids = _.union(temp.concat(tags));
            // 在自定义字体组
            if (currentGroup.value.id === -1 && tags.length) {
                allFont.value = [
                    {
                        name: "",
                        id: 0,
                        type: 0,
                        assets: []
                    }, 
                ];
                return;
            }
            if (currentGroup.value.id === -1 && !tags.length && !searchQuery.name) {
                handleUpdateAssetGroup();
                return;
            }
            handleSearch();
        };
        var reset = function() {
            var _$ref;
            // 重置数据
            searchQuery.name = "";
            searchQuery.tag_ids = [];
            searchQuery.group_id = 0;
            searchQuery.type = 9;
            currentGroup.value = {
                id: 0,
                name: "",
                type: 0
            };
            (_$ref = layerRef.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFilter();
        };
        var uploadComplete = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!props.assetFontConfig.list) {
                                _ctx.next = 9;
                                break;
                            }
                            if (!(currentGroup.value.id === -1 && !searchQuery.name && !searchQuery.tag_ids.length)) {
                                _ctx.next = 8;
                                break;
                            }
                            _ctx.next = 4;
                            return getAssetsList();
                        case 4:
                            assetFont.value = _ctx.sent;
                            allFont.value = [
                                {
                                    name: "",
                                    id: 0,
                                    type: 0,
                                    assets: assetFont.value
                                }, 
                            ];
                            _ctx.next = 9;
                            break;
                        case 8:
                            {
                                handleSearch();
                            }
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function uploadComplete() {
                return _ref.apply(this, arguments);
            };
        }();
        watch(function() {
            return layerVisible.value;
        }, function(val) {
            if (val) {
                reset();
                handleSearch();
            }
        }, {
            immediate: true
        });
        onMounted(function() {
            getAssistTag();
        });
        return {
            listLoading: listLoading,
            assistTag: assistTag,
            currentGroup: currentGroup,
            searchQuery: searchQuery,
            layerListType: layerListType,
            allFont: allFont,
            assetFont: assetFont,
            layerRef: layerRef,
            systemFontList: systemFontList,
            fontName: fontName,
            layerVisible: layerVisible,
            currentFont: currentFont1,
            systemFont: systemFont,
            forbiddenFont: forbiddenFont,
            handleClick: handleClick,
            handleFontChange: handleFontChange,
            handleSelectFont: handleSelectFont,
            handleUpdateGroup: handleUpdateGroup,
            handleUpdateAssetGroup: handleUpdateAssetGroup,
            handleUpdateKeyword: handleUpdateKeyword,
            handleUpdateFilter: handleUpdateFilter,
            uploadComplete: uploadComplete
        };
    }
});
